import { render, staticRenderFns } from "./PageBreadcrumb.vue?vue&type=template&id=f86ad6a8&scoped=true"
import script from "./PageBreadcrumb.vue?vue&type=script&lang=js"
export * from "./PageBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86ad6a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f86ad6a8')) {
      api.createRecord('f86ad6a8', component.options)
    } else {
      api.reload('f86ad6a8', component.options)
    }
    module.hot.accept("./PageBreadcrumb.vue?vue&type=template&id=f86ad6a8&scoped=true", function () {
      api.rerender('f86ad6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/breadcrumb/PageBreadcrumb.vue"
export default component.exports